import { render, staticRenderFns } from "./OtherCert.vue?vue&type=template&id=6fac30f8&scoped=true"
import script from "./OtherCert.vue?vue&type=script&lang=js"
export * from "./OtherCert.vue?vue&type=script&lang=js"
import style0 from "./OtherCert.vue?vue&type=style&index=0&id=6fac30f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fac30f8",
  null
  
)

export default component.exports